export enum enTypeToastNotificationMessage {
  ERROR = 0,
  SUCCESS = 1
}

export interface IToastNotification {
  messages: INotification[];
}

export interface INotification {
  id: string,
  msg: string,
  type: enTypeToastNotificationMessage
}